import React, { useState,useContext,useEffect } from 'react';
// import { Route, Routes, useLocation, NavLink } from 'react-router-dom';
import { useUserAPI } from '../../components/useUserAPI';
import { SharedInfoContext } from '../../components/SharedInfoContextProvider';
// import { iAeonMiniApp } from '../../library/iaeon_sdk_240405';
// import * as IaeonSdk from './library/iaeon_sdk.js';
import { iAeonGetData } from '../../library/iaeon_sdk.js';
import { iAeonGetLocation } from '../../library/iaeon_sdk.js';
import { iAeonSetData } from '../../library/iaeon_sdk.js';
import { iAeonClose } from '../../library/iaeon_sdk.js';
import { iAeonGetStoreInfo } from '../../library/iaeon_sdk.js';

import styles from '../../styles/Start.module.scss'

// import useSound from 'use-sound';
// import se_08 from '../../sound/s08_se_delay0.mp3';

export function Home(props) {

const [storelistAddress, setStorelistAddress] = useState(false);
const [miniappgpsstorelistAddress, setMiniappgpsstorelistAddress] = useState(false);


useEffect(() => {
	console.log("props.homeHieght: " + props.homeHeight);
}, [props.homeHeight]);

// const [storelistAddress, setStorelistAddress] = useState(false);
// const [key, setKey] = useState(0);
// const [se08_se] = useSound(se_08);
// let [se08_play, { stop: se08_stop }] = useSound(se_08, { key });


//----------------------------------------
// 初期化
//----------------------------------------

useEffect(() => {
	// document.documentElement.classList.add('is_fixed');
	// document.body.classList.add('is_fixed');
	// document.getElementById('header').classList.remove('is_behind');
	// document.getElementById('header').classList.add('is_fixed');
	var elements = document.getElementsByClassName('header_logo');
	Array.from(elements).forEach(function(element) {
		element.classList.add('is_hide');
	});

	//scandit SDK 開始
	if(props.sdkStartFlg === false){
		props.setSdkStartFlg(true);
	}

	if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON 有効
		if(props.posFlg === false){
			//位置情報取得〜会員情報取得までloading表示（スタート画面表示と同時に表示
			document.querySelectorAll('.loadingBox01').forEach(function(element) {
				element.classList.add('is_show');
			});
			document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
				element.classList.add('is_show');
			});
			setTimeout(function(){
				props.setPosFlg(true);
			}, 300);
		}
	}

	// setTimeout(function(){
		// document.documentElement.style.zoom = window.innerWidth / 390;
		if(window.innerWidth >= 320){
			document.documentElement.style.zoom = window.innerWidth / 390;
		}else{
			document.documentElement.style.zoom = 1;
		}
		document.getElementById('fcover').classList.add('is_hide');

		// document.documentElement.style.zoom = window.innerWidth / 390;
		let zratio = window.innerWidth / 390;
		let hratio = window.innerHeight / (window.innerHeight * zratio);
		let realheight = window.innerHeight * hratio;
		let elementA = document.getElementById('startBox');
		if (elementA) {
			elementA.style.height = realheight + 'px';
			props.setHome_realheight(realheight);
			props.setHomeHeight(realheight);
		}

		let sHeight = window.innerHeight;
		//iPhoneSE等の高さが短いものは高さ固定
		// if(props.userData){
		// 	if(props.userData.data){
		// 		if(sHeight <= 760 && props.paramStore !== null){
		// 			sHeight = 760;
		// 		}
		// 	}
		// }
		let wzoom = window.innerWidth / 390;
		let zHeight = sHeight * wzoom;
		let nHeight = sHeight - (zHeight - sHeight);
		console.log("sHeight: "+sHeight);
		console.log("wzoom: "+wzoom);
		console.log("zHeight: "+zHeight);
		console.log("nHeight: "+nHeight);
		// if(nHeight <= 680){
			let element = document.getElementById('startBox_wrap');
			if (element) {
				element.style.height = nHeight + 'px';
				props.setHome_nHeight(nHeight);
			}
		// }
		let element2 = document.getElementById('storeList');
		if (element2) {
			// element2.style.height = 'calc(' + nHeight + 'px - 178px)';
			if(props.userData){
			if(props.userData.data){
				if (props.paramStore !== null) {
					element2.style.height = 'calc(' + nHeight + 'px - 322px)';
				}else{
					element2.style.height = 'calc(' + nHeight + 'px - 198px)';
				}
			}
			}
		}
	// }, 300);
	//iPhoneSE等の高さが短いものは店舗なし表示の位置調整
	// if(props.userData){
	// 	if(props.userData.data){
	// 		if(sHeight <= 730 && props.paramStore !== null && document.getElementById('storeBox_noStore')){
	// 			document.getElementById('storeBox_noStore').style.top = "50px";
	// 		}else if(sHeight <= 760 && props.paramStore !== null && document.getElementById('storeBox_noStore')){
	// 			document.getElementById('storeBox_noStore').style.top = "80px";
	// 		}
	// 	}
	// }
	setTimeout(function(){
		// document.documentElement.style.zoom = window.innerWidth / 390;
		if(window.innerWidth >= 320){
			document.documentElement.style.zoom = window.innerWidth / 390;
		}else{
			document.documentElement.style.zoom = 1;
		}
		document.getElementById('fcover').classList.add('is_hide');

		sHeight = window.innerHeight;
		//iPhoneSE等の高さが短いものは高さ固定
		// if(props.userData){
		// 	if(props.userData.data){
		// 		if(sHeight <= 760 && props.paramStore !== null){
		// 			sHeight = 760;
		// 		}
		// 	}
		// }
		wzoom = window.innerWidth / 390;
		zHeight = sHeight * wzoom;
		nHeight = sHeight - (zHeight - sHeight);
		console.log("sHeight: "+sHeight);
		console.log("wzoom: "+wzoom);
		console.log("zHeight: "+zHeight);
		console.log("nHeight: "+nHeight);
		// if(nHeight <= 680){
			let element = document.getElementById('startBox_wrap');
			if (element) {
				element.style.height = nHeight + 'px';
			}
		// }
		element2 = document.getElementById('storeList');
		if (element2) {
			// element2.style.height = 'calc(' + nHeight + 'px - 178px)';
			if(props.userData){
			if(props.userData.data){
				if (props.paramStore !== null) {
					element2.style.height = 'calc(' + nHeight + 'px - 322px)';
				}else{
					element2.style.height = 'calc(' + nHeight + 'px - 198px)';
				}
			}
			}
		}
		//iPhoneSE等の高さが短いものは店舗なし表示の位置調整
		// if(props.userData){
		// 	if(props.userData.data){
		// 		if(sHeight <= 730 && props.paramStore !== null && document.getElementById('storeBox_noStore')){
		// 			document.getElementById('storeBox_noStore').style.top = "50px";
		// 		}else if(sHeight <= 760 && props.paramStore !== null && document.getElementById('storeBox_noStore')){
		// 			document.getElementById('storeBox_noStore').style.top = "80px";
		// 		}
		// 	}
		// }
	}, 300);
	setTimeout(function(){
		// document.documentElement.style.zoom = window.innerWidth / 390;
		if(window.innerWidth >= 320){
			document.documentElement.style.zoom = window.innerWidth / 390;
		}else{
			document.documentElement.style.zoom = 1;
		}
	}, 600);
	// if(window.innerWidth >= 320){
	// 	document.querySelector("[name=viewport]").setAttribute('content','width=device-width, user-scalable=no');
	// }else{
	// 	document.querySelector("[name=viewport]").setAttribute('content','width=390, user-scalable=no');
	// }

	function getMobileOS() {
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;

		// Android検出
		if (/android/i.test(userAgent)) {
			var match = userAgent.match(/Android\s+([\d\.]+)/i);
			return { os: "Android", version: match ? match[1] : "不明" };
		}
		// iOS検出
		if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
			var match = userAgent.match(/OS\s+([\d\_]+)/i);
			return { os: "iOS", version: match ? match[1].replace(/_/g, '.') : "不明" };
		}

		return { os: "不明", version: "不明" };
	}

	var mobileOS = getMobileOS();
	console.log(`OS: ${mobileOS.os}, version: ${mobileOS.version}`);

	props.setOsinfo(mobileOS);

}, [props.userData]);


//----------------------------------------
//
//----------------------------------------

const sharedInfo = useContext(SharedInfoContext);
const { terminalCode, updateTerminalCode } = useContext(SharedInfoContext);
const { storeCode, updateStoreCode } = useContext(SharedInfoContext);
const { token, updateToken } = useContext(SharedInfoContext);
const { gateFlag, updateGateFlag } = useContext(SharedInfoContext);
const { storeInfo, updateStoreInfo } = useContext(SharedInfoContext);
const { bandColor, updateBandColor } = useContext(SharedInfoContext);
const { transactionno, updateTransactionno} = useContext(SharedInfoContext);
const { glocation, updategLocation } = useContext(SharedInfoContext);
const { dammingCheckRunInterval, updateDammingCheckRunInterval } = useContext(SharedInfoContext);

const { GPSStorelistData } = props;
const { miniappgpsstorelistData } = props;
const { storelistData } = props;


//----------------------------------------
//近く対象店舗リストAPI：レスポンス
//----------------------------------------

useEffect(() => {
	if(GPSStorelistData){
		if (GPSStorelistData.data) { //SUCCESS
			console.log(`【GPSStorelistAPI】 storeList[0].storeCode: ${GPSStorelistData.data.storeList[0].storeCode}`);
			console.log(`【GPSStorelistAPI】 storeList[0].storeName: ${GPSStorelistData.data.storeList[0].storeName}`);
			console.log(`【GPSStorelistAPI】 storeList[0].gateFlag: ${GPSStorelistData.data.storeList[0].gateFlag}`);

			GPSStorelistData.data.storeList.forEach((item) => {
				if (props.paramStore === item.storeCode) {
					selectStore(item.storeCode, item.gateFlag,"gps");
				}
			});
			// const sstore = GPSStorelistData.data.storeList[0].storeCode;
			//イオンスタイル幕張新都心フードストア
			// const sstore = "0000082900";
			// updateStoreCode(sstore);
			// updateGateFlag(GPSStorelistData.data.storeList[0].gateFlag);
			// shoppingStartAPI(sstore);

			//該当店舗抽出
			// const filteredStores = GPSStorelistData.data.storeList.filter(store => store.storeCode === sstore);
			// console.log("該当店舗情報");
			// console.log(filteredStores[0]);
			// updateStoreInfo(filteredStores[0]);

		}
	}
}, [GPSStorelistData,props.paramStore]);

const [count, setCount] = useState(0);


//----------------------------------------
//4.店舗情報取得API（住所取得 未使用：24.09.05
//----------------------------------------

function callAPI_4_miniappgpsstorelist(snum,scode){
	console.log("----------------------------");
	console.log("【iAeonGetStoreInfo_mini】post");
    let successCall_4 = function(success){
		var aaa = success;
		console.log('【iAeonGetStoreInfo_mini】success：' + aaa);
		console.log('【iAeonGetStoreInfo_mini】id：' + aaa.id);
		console.log('【iAeonGetStoreInfo_mini】code：' + aaa.code);
		console.log('【iAeonGetStoreInfo_mini】name：' + aaa.name);
		console.log('【iAeonGetStoreInfo_mini】prefecture：' + aaa.prefecture);
		console.log('【iAeonGetStoreInfo_mini】city：' + aaa.city);
		console.log('【iAeonGetStoreInfo_mini】street：' + aaa.street);

		let saddress = aaa.prefecture + aaa.city + aaa.street;
		miniappgpsstorelistData.data.storeList[snum].storeAddress = saddress;
		// const newStoreAddressArr = [...props.storeAddressArr];
		// newStoreAddressArr[snum] = saddress;
		// props.setStoreAddressArr(newStoreAddressArr);

		console.log('【iAeonGetStoreInfo_mini】newStoreAddressArr['+snum+']：' + saddress);
		// if(slast === true){ //最後
		// 	setTimeout(function(){
		// 		setMiniappgpsstorelistAddress(true);
		// 	}, 200);
		// }
		setCount(snum);
		var nnum = snum + 1;
		if(nnum < miniappgpsstorelistData.data.storeList.length){
			callAPI_4_miniappgpsstorelist(nnum,miniappgpsstorelistData.data.storeList[nnum].storeCode);
		}
    }
    let errorCall_4 = function(error){
		var bbb = error;
		console.log('【iAeonGetStoreInfo_mini】error：' + bbb.error_code);

		miniappgpsstorelistData.data.storeList[snum].storeAddress = null;
		// const newStoreAddressArr = [...props.storeAddressArr];
		// newStoreAddressArr[snum] = null;
		// props.setStoreAddressArr(newStoreAddressArr);
		setCount(snum);
		var nnum = snum + 1;
		if(nnum < miniappgpsstorelistData.data.storeList.length){
			callAPI_4_miniappgpsstorelist(nnum,miniappgpsstorelistData.data.storeList[nnum].storeCode);
		}
    }
    iAeonGetStoreInfo({"store_code":scode}).then(successCall_4).catch(errorCall_4);
}


//----------------------------------------
//ミニアプリ用近くの店舗API：レスポンス
//----------------------------------------

useEffect(() => { //未使用：24.09.05 → 使用：25.03.28
	if(miniappgpsstorelistData){
		if (miniappgpsstorelistData.data) { //SUCCESS
			if(miniappgpsstorelistData.data.storeList.length > 0){
				console.log(`【miniappgpsstorelistAPI】 storeList[0].storeCode: ${miniappgpsstorelistData.data.storeList[0].storeCode}`);
				console.log(`【miniappgpsstorelistAPI】 storeList[0].storeName: ${miniappgpsstorelistData.data.storeList[0].storeName}`);
				console.log(`【miniappgpsstorelistAPI】 storeList[0].storeAddress: ${miniappgpsstorelistData.data.storeList[0].storeAddress}`);
				console.log(`【miniappgpsstorelistAPI】 storeList[0].distance: ${miniappgpsstorelistData.data.storeList[0].distance}`);
				console.log(`【miniappgpsstorelistAPI】 storeList[0].gateFlag: ${miniappgpsstorelistData.data.storeList[0].gateFlag}`);

				if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
					if(miniappgpsstorelistData.data.storeList.length === 0){
						setMiniappgpsstorelistAddress(true);
					}else{
						// for(var i=0;i<miniappgpsstorelistData.data.storeList.length;i++){
						// 	if(i === (miniappgpsstorelistData.data.storeList.length - 1)){ //最後
						// 		callAPI_4_miniappgpsstorelist(i,miniappgpsstorelistData.data.storeList[i].storeCode,true);
						// 	}else{
						// 		callAPI_4_miniappgpsstorelist(i,miniappgpsstorelistData.data.storeList[i].storeCode,false);
						// 	}
						// }
						// callAPI_4_miniappgpsstorelist(0,miniappgpsstorelistData.data.storeList[0].storeCode);
						setMiniappgpsstorelistAddress(true);
					}
				}else{ //iAEON無効
					setMiniappgpsstorelistAddress(true);

					// document.querySelectorAll('.loadingBox01').forEach(function(element) {
					// 	element.classList.remove('is_show');
					// });
					// document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
					// 	element.classList.remove('is_show');
					// });
				}

				// let select_count = 0;
				miniappgpsstorelistData.data.storeList.forEach((item) => {
					if (props.paramStore === item.storeCode) {
						console.log("お気に入り店舗と一覧の一致あり：店舗選択有効");
						selectStore(item.storeCode, item.gateFlag,"gps");
						// select_count += 1;
					}
				});

				document.querySelectorAll('.loadingBox01').forEach(function(element) {
					element.classList.remove('is_show');
				});
				document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
					element.classList.remove('is_show');
				});
				// setTimeout(function(){
				// 	if (select_count == 0) {
				// 		console.log("お気に入り店舗と一覧の一致なし：店舗選択無効");
				// 		props.setActiveStore();
				// 	}
				// }, 100);

			}

		}
	}
}, [miniappgpsstorelistData,props.paramStore]);


//----------------------------------------
//店舗情報取得API：レスポンス（未使用 25.03.26
//----------------------------------------

useEffect(() => {
	if(storelistData){
		if (storelistData.data) { //SUCCESS
			console.log(`【storelistAPI】 storeList[0].storeCode: ${storelistData.data.storeList[0].storeCode}`);
			console.log(`【storelistAPI】 storeList[0].storeName: ${storelistData.data.storeList[0].storeName}`);
			console.log(`【storelistAPI】 storeList[0].storeAddress: ${storelistData.data.storeList[0].storeAddress}`);
			console.log(`【storelistAPI】 storeList[0].distance: ${storelistData.data.storeList[0].distance}`);
			console.log(`【storelistAPI】 storeList[0].gateFlag: ${storelistData.data.storeList[0].gateFlag}`);

			if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
				if(storelistData.data.storeList.length === 0){
					setStorelistAddress(true);

					document.querySelectorAll('.loadingBox01').forEach(function(element) {
						element.classList.remove('is_show');
					});
					document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
						element.classList.remove('is_show');
					});
				}else{
					// for(var i=0;i<storelistData.data.storeList.length;i++){
					// 	if(i === (storelistData.data.storeList.length - 1)){ //最後
					// 		callAPI_4_storelist(i,storelistData.data.storeList[i].storeCode,true);
					// 	}else{
					// 		callAPI_4_storelist(i,storelistData.data.storeList[i].storeCode,false);
					// 	}
					// }
					setStorelistAddress(true);

					document.querySelectorAll('.loadingBox01').forEach(function(element) {
						element.classList.remove('is_show');
					});
					document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
						element.classList.remove('is_show');
					});
				}
			}else { //iAEON無効
				setStorelistAddress(true);

				document.querySelectorAll('.loadingBox01').forEach(function(element) {
					element.classList.remove('is_show');
				});
				document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
					element.classList.remove('is_show');
				});
			}

			// storelistData.data.storeList.forEach((item) => {
			// 	if (props.paramStore === item.storeCode) {
			// 		selectStore(item.storeCode, item.gateFlag,"fav");
			// 	}
			// });

		}
	}
}, [storelistData,props.paramStore]);


//----------------------------------------
//店舗選択
//----------------------------------------

const audioContext = new (window.AudioContext || window.webkitAudioContext)();

const selectStore = (sstore,sgateflg,type) => {
	if(props.closeStore.indexOf(sstore) == -1){
	// const selectStore = () => {
		updateStoreCode(sstore);
		updateGateFlag(sgateflg);
		props.setActiveStore(sstore);

		//選択店舗抽出
		// const filteredStores = GPSStorelistData.data.storeList.filter(store => store.storeCode === sstore);
		if(type === "fav"){
			const filteredStoresFav = storelistData.data.storeList.filter(store => store.storeCode === sstore);
			console.log("【選択店舗情報】");
			console.log(filteredStoresFav[0]);
			updateStoreInfo(filteredStoresFav[0]);
		}else{
			const filteredStoresGps = miniappgpsstorelistData.data.storeList.filter(store => store.storeCode === sstore);
			console.log("【選択店舗情報】");
			console.log(filteredStoresGps[0]);
			updateStoreInfo(filteredStoresGps[0]);
		}
		// se08_se();
		// props.setErrFlg(true);
		// var error_msg = ";[000001];初期化失敗;;;";
		// var error_msg = ";[000004];リクエストパラメータ不正;;;";
		// var error_msg = ";[000059];位置情報使用権限無し;;;";
		// props.setErr([true, "000001", error_msg]);
	}

}


//----------------------------------------
//ご利用方法を見る
//----------------------------------------

const goIntro = () => {
	props.setPage("intro");
	// se08_se();
	props.setSoundState("se08_se");
}


//----------------------------------------
//買物データ復元
//----------------------------------------

//19.データ取得API
function callAPI_19(){
	console.log("----------------------------");
	console.log("【iAeonGetData】post");
    let successCall_19 = function(success){
        var aaa = JSON.stringify(success);
		// var jsonString = success.replace(/”}$/, '"}}');
		// var aaa = JSON.perse(jsonString);
		console.log('【iAeonGetData】success：' + aaa);
        var bbb = JSON.parse(aaa);
		console.log('【iAeonGetData】bbb：');
		console.log(bbb);
        var ccc = JSON.parse(bbb.value);
		console.log('【iAeonGetData】ccc：');
		console.log(ccc);
		console.log('【iAeonGetData】transactionno：' + ccc.transactionno);
		console.log('【iAeonGetData】date：' + ccc.date);
		console.log('【iAeonGetData】storeCode：' + ccc.storeCode);
		// console.log('【iAeonGetData】bandColor：' + ccc.bandColor);

		// 現在の日付と時刻を取得
		const todays = new Date();
		// 日付を YYYY-MM-DD 形式で表示
		const dateToday = todays.toISOString().split('T')[0];
		console.log("本日の日付: "+dateToday);

		if(ccc.transactionno !== null && ccc.transactionno !== "undefined" && ccc.transactionno !== undefined){
			console.log("【iAeonGetData】買物データあり");
			if(dateToday === ccc.date){ //日付一致
				console.log("【iAeonGetData】日付一致");
				if(sharedInfo.storeCode === ccc.storeCode){ //店舗ID一致
					console.log("【iAeonGetData】店舗ID一致 → 買物復元");

					// recoveryAPI(ccc.transactionno,sharedInfo.storeCode);
					updateTransactionno(ccc.transactionno);
					props.setErrFlg(true);
					props.setErr([true,`shopping_recovery`,`;;;;;`]);

				}else {
					console.log("【iAeonGetData】店舗ID一致せず 復元なし 買物開始");

					if(process.env.REACT_APP_GPS === "true"){ //iAEON GPS有効
						console.log("iAEON GPS有効");
						//12.位置情報取得API
						callAPI_12_checkin(false);

					}else{ //iAEON GPS無効
						console.log("iAEON GPS無効");
						//イオンスタイル幕張新都心フードストア 0000082900
						// var newLocation = "35.656429, 140.027035";
						//イオンスタイル千葉みなと 0000052160
						var newLocation = "35.600458, 140.113616";
						storecheckinAPI(newLocation,sharedInfo.storeCode);
						// shoppingStartAPI(sharedInfo.storeCode);
					}
				}
			}else {
				console.log("【iAeonGetData】日付一致せず 復元なし 買物開始");

				if(process.env.REACT_APP_GPS === "true"){ //iAEON GPS有効
					console.log("iAEON GPS有効");
					//12.位置情報取得API
					callAPI_12_checkin(false);

				}else{ //iAEON GPS無効
					console.log("iAEON GPS無効");
					//イオンスタイル幕張新都心フードストア 0000082900
					// var newLocation = "35.656429, 140.027035";
					//イオンスタイル千葉みなと 0000052160
					var newLocation = "35.600458, 140.113616";
					storecheckinAPI(newLocation,sharedInfo.storeCode);
					// shoppingStartAPI(sharedInfo.storeCode);
				}
			}
		}else{
			console.log("【iAeonGetData】買物データなし 復元なし 買物開始");

			if(process.env.REACT_APP_GPS === "true"){ //iAEON GPS有効
				console.log("iAEON GPS有効");
				//12.位置情報取得API
				callAPI_12_checkin(false);

			}else{ //iAEON GPS無効
				console.log("iAEON GPS無効");
				//イオンスタイル幕張新都心フードストア 0000082900
				// var newLocation = "35.656429, 140.027035";
				//イオンスタイル千葉みなと 0000052160
				var newLocation = "35.600458, 140.113616";
				storecheckinAPI(newLocation,sharedInfo.storeCode);
				// shoppingStartAPI(sharedInfo.storeCode);
			}
		}
    }
    let errorCall_19 = function(error){
        var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonGetData】error：' + bbb);
		console.log("【iAeonGetData】買物データなし 復元なし 買物開始");

		if(process.env.REACT_APP_GPS === "true"){ //iAEON GPS有効
			console.log("iAEON GPS有効");
			//12.位置情報取得API
			callAPI_12_checkin(false);

		}else{ //iAEON GPS無効
			console.log("iAEON GPS無効");
			//イオンスタイル幕張新都心フードストア 0000082900
			// var newLocation = "35.656429, 140.027035";
			//イオンスタイル千葉みなと 0000052160
			var newLocation = "35.600458, 140.113616";
			storecheckinAPI(newLocation,sharedInfo.storeCode);
			// shoppingStartAPI(sharedInfo.storeCode);
		}
    }
    iAeonGetData({"key": "shopping_data"}).then(successCall_19).catch(errorCall_19);
    // window.iAeonMiniApp.iAeonGetData({"key": "shopping_data"}).then(successCall_19);
}


const [recoveryState, setRecoveryState] = useState(false)

//12.位置情報取得API
function callAPI_12_checkin(recoverFlg){
	//仮対応
	// let pos = "35.600458, 140.113616";
	// updategLocation(pos);
		// if(recoverFlg === true){
		// 	recoveryAPI(sharedInfo.transactionno,sharedInfo.storeCode);
		// }else{
		// 	var newLocation = "35.600458, 140.113616";
		// 	storecheckinAPI(newLocation,sharedInfo.storeCode);
		// }
	// setRecoveryState(recoverFlg);
	// var newLocation = "35.600458, 140.113616";
	// storecheckinAPI(newLocation,sharedInfo.storeCode);

	//本対応
    let successCall_12 = function(success){
        var aaa = success;
		console.log('【iAeonGetLocation】success：' + aaa);
		console.log('【iAeonGetLocation】latitude：' + aaa.latitude);
		console.log('【iAeonGetLocation】longitude：' + aaa.longitude);
		let pos = aaa.latitude + ", " + aaa.longitude;
		updategLocation(pos);
		// if(recoverFlg === true){
		// 	recoveryAPI(sharedInfo.transactionno,sharedInfo.storeCode);
		// }else{
		// 	var newLocation = aaa.latitude + ", " + aaa.longitude;
		// 	storecheckinAPI(newLocation,sharedInfo.storeCode);
		// }
		setRecoveryState(recoverFlg);
		if(process.env.REACT_APP_GPS === "true"){ //iAEON GPS有効
			console.log("iAEON GPS有効");
			var newLocation = aaa.latitude + ", " + aaa.longitude;
			storecheckinAPI(newLocation,sharedInfo.storeCode);
		}else{ //iAEON GPS無効
			var newLocation = "35.600458, 140.113616";
			storecheckinAPI(newLocation,sharedInfo.storeCode);
		}
    }
    let errorCall_12 = function(error){
		var bbb = error;
		console.log('【iAeonGetLocation】error: ' + error.error_code + " : " + error.message);
		props.setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		props.setErr([true, error.error_code, error_msg]);
    }
	console.log('【iAeonGetLocation】call');
    iAeonGetLocation().then(successCall_12).catch(errorCall_12);
}

useEffect(() => {
	if(props.recoveryChoice === true){
		console.log("【iAeonGetData】店舗ID一致 → 買物復元");
		// recoveryAPI(sharedInfo.transactionno,sharedInfo.storeCode);
		callAPI_12_checkin(true);

	}else if(props.recoveryChoice === false){
		console.log("【iAeonGetData】買物データなし 復元なし 買物開始");

		if(process.env.REACT_APP_GPS === "true"){ //iAEON GPS有効
			console.log("iAEON GPS有効");
			//12.位置情報取得API
			callAPI_12_checkin(false);

		}else{ //iAEON GPS無効
			console.log("iAEON GPS無効");
			//イオンスタイル幕張新都心フードストア 0000082900
			// var newLocation = "35.656429, 140.027035";
			//イオンスタイル千葉みなと 0000052160
			var newLocation = "35.600458, 140.113616";
			storecheckinAPI(newLocation,sharedInfo.storeCode);
			// shoppingStartAPI(sharedInfo.storeCode);
		}
	}
}, [props.recoveryChoice]);


//----------------------------------------
//買物開始
//----------------------------------------

const StartShopping = () => {
	console.log("REACT_APP_IAEON_FLG: " + process.env.REACT_APP_IAEON_FLG);
	if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
		console.log("iAEON 有効：買物データ確認");
		// callAPI_6();
		callAPI_19();
	}else{ //iAEON無効
		console.log("iAEON 無効：買物開始");

		if(process.env.REACT_APP_GPS === "true"){ //iAEON GPS有効
			console.log("iAEON GPS有効");
			//12.位置情報取得API
			callAPI_12_checkin(false);

		}else{ //iAEON GPS無効
			console.log("iAEON GPS無効");
			//イオンスタイル幕張新都心フードストア 0000082900
			// var newLocation = "35.656429, 140.027035";
			//イオンスタイル千葉みなと 0000052160
			var newLocation = "35.600458, 140.113616";
			//座標確認あり（固定座標
			storecheckinAPI(newLocation,sharedInfo.storeCode);
			//座標確認なし
			// shoppingStartAPI(sharedInfo.storeCode);
		}
	}
	// se08_se();
	props.setSoundState("se08_se");
}


//----------------------------------------
//店舗チェックインAPI：レスポンス
//----------------------------------------

const { storecheckinAPI, data: storecheckinData, loading: storecheckinLoading, error: storecheckinError } = useUserAPI();

useEffect(() => {
	if(storecheckinData){
		if (storecheckinData.data) { //SUCCESS
			console.log(`【storecheckinAPI】 storeCheckInFlag: ${storecheckinData.data.storeCheckInFlag}`);

			if(storecheckinData.data.storeCheckInFlag === "1"){ //店舗チェックインOK
				console.log("【storecheckinAPI】 店舗チェックイン: OK");
				console.log("買物復元あり → recoveryAPI");
				if(recoveryState === true && process.env.REACT_APP_IAEON_FLG === "true"){ //買物復元あり
					recoveryAPI(sharedInfo.transactionno,sharedInfo.storeCode);
				}else{ //買物復元なし
					console.log("買物復元なし → shoppingStartAPI");
					shoppingStartAPI(sharedInfo.storeCode);
				}
			}else{ //店舗チェックインNG
				console.log("【storecheckinAPI】 店舗チェックイン: NG");
				props.setErrFlg(true);
				props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_CHECKIN]);
				// props.setErr([true,``,`;チェックインエラー;レジゴー有効範囲から離れています。300m以内に移動して再度お試しください。;;;`]);
			}
		}else{ //ERROR
			console.log(`【storecheckinAPI】 errorCode: ${storecheckinData.errorCode}`);
			console.log(`【storecheckinAPI】 errorMessage: ${storecheckinData.errorMessage}`);
			console.log(`【storecheckinAPI】 isSuccess: ${storecheckinData.isSuccess}`);

			// props.setErrNum(`${shoppingStartData.errorCode}`);
			// props.setShowModal(true);
			// props.setErrTxt(`${shoppingStartData.errorMessage}`);
			props.setErrFlg(true);
			props.setErr([true,`${storecheckinData.errorCode}`,`${storecheckinData.errorMessage}`]);
		}
	}
	if(storecheckinError){
		console.log("storecheckinError");
		console.log(storecheckinError);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(storecheckinLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [storecheckinData,storecheckinLoading,storecheckinError]);


//----------------------------------------
//買物開始API：レスポンス
//----------------------------------------

const { shoppingStartAPI, data: shoppingStartData, loading: shoppingStartLoading, error: shoppingStartError } = useUserAPI();

useEffect(() => {
	if(shoppingStartData){
		if (shoppingStartData.data) { //SUCCESS
			console.log(`【shoppingStartAPI】 transactionno: ${shoppingStartData.data.transactionno}`);
			console.log(`【shoppingStartAPI】 token: ${shoppingStartData.data.token}`);
			console.log(`【shoppingStartAPI】 bandColor: ${shoppingStartData.data.bandColor}`);
			console.log(`【shoppingStartAPI】 runInterval: ${shoppingStartData.data.runInterval}`);
			console.log(`【shoppingStartAPI】 bonusFlag: ${shoppingStartData.data.bonusFlag}`);
			console.log(`【shoppingStartAPI】 lotteryFlag: ${shoppingStartData.data.lotteryFlag}`);
			if(process.env.REACT_APP_FRONT_CHECK === "true"){ //せき止め有効
				console.log(`【shoppingStartAPI】 dammingCheckRunInterval: ${shoppingStartData.data.dammingCheckRunInterval}`);
			}

			// if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
			// 	callAPI_18(shoppingStartData.data.transactionno);
			// }

			if(shoppingStartData.data.bandColor === "#A1C237"){ //日
				updateBandColor("bandcol01_SUNDAY");
			}else if(shoppingStartData.data.bandColor === "#CE57AF"){ //月
				updateBandColor("bandcol02_MONDAY");
			}else if(shoppingStartData.data.bandColor === "#C93A40"){ //火
				updateBandColor("bandcol03_TUESDAY");
			}else if(shoppingStartData.data.bandColor === "#00A0F0"){ //水
				updateBandColor("bandcol04_WEDNESDAY");
			}else if(shoppingStartData.data.bandColor === "#FFB42D"){ //木
				updateBandColor("bandcol05_THURSDAY");
			}else if(shoppingStartData.data.bandColor === "#00A546"){ //金
				updateBandColor("bandcol06_FRIDAY");
			}else if(shoppingStartData.data.bandColor === "#B60081"){ //土
				updateBandColor("bandcol07_SATURDAY");
			}

			updateTransactionno(shoppingStartData.data.transactionno);
			updateToken(shoppingStartData.data.token);
			if(process.env.REACT_APP_FRONT_CHECK === "true"){ //せき止め有効
				updateDammingCheckRunInterval(shoppingStartData.data.dammingCheckRunInterval);
			}

			if(sharedInfo.storeInfo.attentionkagoUrl.attentionkagoImgAndroidJ === null){ //アテンション画像なし
				document.getElementById('header').classList.remove('is_hide');
				document.getElementById('header').classList.add('is_behind');
				document.getElementById('header').classList.add('is_fixed');
				props.setPage("shopping");
			}else{ //アテンション画像あり
				props.setPage("attention");
			}
			props.setShoppingStData(shoppingStartData);
		}else{ //ERROR
			console.log(`【shoppingStartAPI】 errorCode: ${shoppingStartData.errorCode}`);
			console.log(`【shoppingStartAPI】 errorMessage: ${shoppingStartData.errorMessage}`);
			console.log(`【shoppingStartAPI】 isSuccess: ${shoppingStartData.isSuccess}`);

			// props.setErrNum(`${shoppingStartData.errorCode}`);
			// props.setShowModal(true);
			// props.setErrTxt(`${shoppingStartData.errorMessage}`);
			props.setErrFlg(true);
			props.setErr([true,`${shoppingStartData.errorCode}`,`${shoppingStartData.errorMessage}`]);
		}
	}
	if(shoppingStartError){
		console.log("shoppingStartError");
		console.log(shoppingStartError);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(shoppingStartLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [shoppingStartData,shoppingStartLoading,shoppingStartError]);


//----------------------------------------
//取引復旧API：レスポンス
//----------------------------------------

const { recoveryAPI, data: recoveryData, loading: recoveryLoading, error: recoveryError } = useUserAPI();

useEffect(() => {
	if(recoveryData){
		if (recoveryData.data) { //SUCCESS
			console.log("【recoveryAPI】recoveryData:");
			console.log(recoveryData);
			console.log(`【recoveryAPI】 transactionno: ${recoveryData.data.transactionno}`);
			console.log(`【recoveryAPI】 token: ${recoveryData.data.token}`);
			console.log(`【recoveryAPI】 bandColor: ${recoveryData.data.bandColor}`);
			console.log(`【recoveryAPI】 runInterval: ${recoveryData.data.runInterval}`);
			console.log(`【recoveryAPI】 bonusFlag: ${recoveryData.data.bonusFlag}`);
			console.log(`【recoveryAPI】 lotteryFlag: ${recoveryData.data.lotteryFlag}`);
			if(process.env.REACT_APP_FRONT_CHECK === "true"){ //せき止め有効
				console.log(`【recoveryAPI】 dammingCheckRunInterval: ${recoveryData.data.dammingCheckRunInterval}`);
			}

			// callAPI_18(recoveryData.data.transactionno);

			if(recoveryData.data.bandColor === "#A1C237"){ //日
				updateBandColor("bandcol01_SUNDAY");
			}else if(recoveryData.data.bandColor === "#CE57AF"){ //月
				updateBandColor("bandcol02_MONDAY");
			}else if(recoveryData.data.bandColor === "#C93A40"){ //火
				updateBandColor("bandcol03_TUESDAY");
			}else if(recoveryData.data.bandColor === "#00A0F0"){ //水
				updateBandColor("bandcol04_WEDNESDAY");
			}else if(recoveryData.data.bandColor === "#FFB42D"){ //木
				updateBandColor("bandcol05_THURSDAY");
			}else if(recoveryData.data.bandColor === "#00A546"){ //金
				updateBandColor("bandcol06_FRIDAY");
			}else if(recoveryData.data.bandColor === "#B60081"){ //土
				updateBandColor("bandcol07_SATURDAY");
			}

			updateTransactionno(recoveryData.data.transactionno);
			updateToken(recoveryData.data.token);
			if(process.env.REACT_APP_FRONT_CHECK === "true"){ //せき止め有効
				updateDammingCheckRunInterval(recoveryData.data.dammingCheckRunInterval);
			}

			if(sharedInfo.storeInfo.attentionkagoUrl.attentionkagoImgAndroidJ === null){ //アテンション画像なし
				document.getElementById('header').classList.remove('is_hide');
				document.getElementById('header').classList.add('is_behind');
				document.getElementById('header').classList.add('is_fixed');
				props.setPage("shopping");
			}else{ //アテンション画像あり
				props.setPage("attention");
			}
			props.setShoppingStData(recoveryData);
			props.setShoppingData(recoveryData);
		}else{ //ERROR
			console.log(`【shoppingStartAPI】 errorCode: ${recoveryData.errorCode}`);
			console.log(`【shoppingStartAPI】 errorMessage: ${recoveryData.errorMessage}`);
			console.log(`【shoppingStartAPI】 isSuccess: ${recoveryData.isSuccess}`);

			// props.setErrNum(`${shoppingStartData.errorCode}`);
			// props.setShowModal(true);
			// props.setErrTxt(`${shoppingStartData.errorMessage}`);
			props.setErrFlg(true);
			props.setErr([true,`${recoveryData.errorCode}`,`${recoveryData.errorMessage}`]);
		}
	}
	if(recoveryError){
		console.log("shoppingStartError");
		console.log(recoveryError);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(recoveryLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [recoveryData,recoveryLoading,recoveryError]);


//----------------------------------------
//未使用
//----------------------------------------

const delPolicy = () => {
	if(process.env.REACT_APP_DEBUG === "true" && process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
		callAPI_18_delete();
		// se08_se();
		props.setSoundState("se08_se");
	}
}
//18.データ保存API（ポリシー削除
function callAPI_18_delete(){
	console.log("----------------------------");
	console.log("【iAeonSetData】post");
    let successCall_18 = function(success){
        // var aaa = JSON.stringify(success);
        // console.log('successCall：' + aaa);
		var aaa = success;
		console.log('【iAeonSetData】success：' + aaa);
    }
    let errorCall_18 = function(error){
        // var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonSetData】error: ' + error.error_code + " : " + error.message);
    }
    iAeonSetData({"mode":"delete", "key": "policy_data"}).then(successCall_18).catch(errorCall_18);
}

const onAeonPay = () => {
	// se08_se();
	props.setSoundState("se08_se");
	//23.決済待ち受けAPIx
	// callAPI_23();
	//22.クローズAPI（ AEON PAY呼び出し
	callAPI_22();
}

//22.クローズAPI（ AEON PAY呼び出し
function callAPI_22(){
	let successCall_22 = function(success){
		var aaa = success;
		console.log('【iAeonClose】success：' + aaa);
	}
	let errorCall_22 = function(error){
		var bbb = error;
		console.log('【iAeonClose】error: ' + error.error_code + " : " + error.message);
		props.setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		props.setErr([true, error.error_code, error_msg]);
	}
	// iAeonClose().then(successCall_22).catch(errorCall_22);
	iAeonClose({"page_name": "aeonpayBarcode"}).then(successCall_22).catch(errorCall_22);
}


return (
<>

<div id="startBox" data-storelistCount={props.storelistCount} className={styles.startBox} styleName={`${props.home_realheight ? 'height:'+props.home_realheight+'px' : ''}`}>
<div id="startBox_wrap" className={styles.startBox_wrap} styleName={`${props.home_nHeight ? 'height:'+props.home_nHeight+'px' : ''}`}>
	<div className={styles.startBox_blank}></div>

	<div className={styles.startBox_titBox}>
		<h1 className={styles.startBox_tit}>
			<img src="/images/logo_regigo01.svg" alt="レジゴー" width="234" height="73"/>
		</h1>
		<div className={styles.storeBox_chara}>
			<img src="/images/img_start_chara.svg" alt="" width="99" height="99"/>
		</div>
	</div>

	<div className={styles.startBox_bottom}>
	<p className={styles.startBox_txt}>ご利用になる店舗を確認してください</p>

	{/* {
		(() => {
			if (props.paramStore !== null) {
			if (storelistData && storelistData.data) {
				return(
				<div className={styles.prevStore}>
				<div className={`${styles.storeBox} ${styles.is_prev} ${(props.activeStore === storelistData.data.storeList[0].storeCode && props.closeStore.indexOf(storelistData.data.storeList[0].storeCode) === -1) ? styles.is_active : ''} ${props.closeStore.indexOf(storelistData.data.storeList[0].storeCode) !== -1 ? styles.is_close : 'abc'}`} onClick={()=>{selectStore(storelistData.data.storeList[0].storeCode,storelistData.data.storeList[0].gateFlag,"fav");}}>
					<div className={styles.storeBox_in}>
						<div className={styles.storeBox_img}>
							<img src={storelistData.data.storeList[0].storeImageUrl.logoImgAndroid+"?v="+storelistData.data.storeList[0].storeImageUrl.version} alt="" width="64" height=""/>
						</div>
						<div className={styles.storeBox_info}>
							<p className={styles.storeBox_info_name}>{storelistData.data.storeList[0].storeName}</p>
							{
								(() => {
									if (props.paramStoreAddress !== null) {
									return(
										<p className={styles.storeBox_info_address}>{props.paramStoreAddress}</p>
									)
									}
								})()
							}
							<p className={styles.storeBox_info_dist}>{Number(storelistData.data.storeList[0].distance)/1000}km</p>
						</div>
					</div>
					<div className={`${styles.storeBox_select} ${styles.storeBox_select01}`}>
						<img src="/images/icn_select01.svg" alt="" width="24" height="24"/>
					</div>
					<div className={`${styles.storeBox_select} ${styles.storeBox_select02}`}>
						<img src="/images/icn_select02.svg" alt="" width="24" height="24"/>
					</div>
				</div>
				</div>
				)
			}else {
				return(
				<div className={`${styles.prevStore} ${styles.is_hide}`}>
				<div className={`${styles.storeBox} ${styles.is_prev}`} >
					<div className={styles.storeBox_in}>
						<div className={styles.storeBox_img}>
						</div>
						<div className={styles.storeBox_info}>
							<p className={styles.storeBox_info_name}>　</p>
							<p className={styles.storeBox_info_address}>　</p>
							<p className={styles.storeBox_info_dist}>　</p>
						</div>
					</div>
					<div className={`${styles.storeBox_select} ${styles.storeBox_select01}`}>
						<img src="/images/icn_select01.svg" alt="" width="24" height="24"/>
					</div>
					<div className={`${styles.storeBox_select} ${styles.storeBox_select02}`}>
						<img src="/images/icn_select02.svg" alt="" width="24" height="24"/>
					</div>
				</div>
				</div>
				)
			}
			}
		})()
	} */}

	<div id="storeList" className={`${styles.storeList} ${styles.is_single}`}>
		<div id="storeList01" className={`${styles.storeListBox} st01 ${styles.is_active}`}>
		{/* <div id="storeList_cover01" className={styles.storeList_cover}></div> */}
		{
			(() => {
				// if (GPSStorelistData && GPSStorelistData.data) {
				// if (miniappgpsstorelistData && miniappgpsstorelistData.data && miniappgpsstorelistAddress) {
				if (miniappgpsstorelistData && miniappgpsstorelistData.data) {

					if(miniappgpsstorelistData.data.storeList.length === 0){
						props.setActiveStore();
						return(
							<>
								<p id="storeBox_noStore" className={`${styles.storeBox_noStore}`} style={{
									top:
									props.homeHeight <= 730
											? '50px'
											: props.homeHeight > 730 && props.homeHeight <= 760
											? '80px'
											: undefined,
								}}>お近くでレジゴーをご利用できる<br/>店舗はございませんでした</p>
							</>
						)
					}else{
						// <MiniappgpsstorelistObj miniappgpsstorelistData={miniappgpsstorelistData} activeStore={props.activeStore} closeStore={props.closeStore} setSoundState={props.setSoundState}></MiniappgpsstorelistObj>
						return(
							<>
							{miniappgpsstorelistData.data.storeList.map((item, index) => (
									<div key={index} className={`${styles.storeBox} ${(props.activeStore === item.storeCode && props.closeStore.indexOf(item.storeCode) === -1) ? styles.is_active : ''} ${props.closeStore.indexOf(item.storeCode) !== -1 ? styles.is_close : 'abc'} ${item.storeCode === "0000006660" ? styles.bg_pink : ''} ${item.storeCode === "0000064580" && window.location.host === "miniapp.regigo.jp" ? styles.bg_green : ''} ${item.storeCode === "0000052000" && window.location.host === "miniapp.irs-test.jp" ? styles.bg_green : ''}`} onClick={()=>{selectStore(item.storeCode,item.gateFlag,"gps");props.setSoundState("se08_se");}}>
										<div className={styles.storeBox_in}>
											<div className={styles.storeBox_img}>
												<img src={item.storeImageUrl.logoImgAndroid+"?v="+item.storeImageUrl.version} alt="" width="64" height=""/>
											</div>
											<div className={styles.storeBox_info}>
												<p className={styles.storeBox_info_name}>{item.storeName}</p>
												{/* {
													(() => {
														if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
															if (item.storeAddress !== null) {
																return(
																	<p className={styles.storeBox_info_address}>{item.storeAddress}</p>
																)
															}else{
																return(
																	<p className={styles.storeBox_info_address}>&nbsp;</p>
																)
															}
														}else{ //iAEON無効
															return(
																// <p className={styles.storeBox_info_address}>{item.storeAddress}</p>
																<></>
															)
														}
													})()
												} */}
												<p className={styles.storeBox_info_dist}>{Number(item.distance)/1000}km</p>
											</div>
										</div>
										<div className={`${styles.storeBox_select} ${styles.storeBox_select01}`}>
											<img src="/images/icn_select01.svg" alt="" width="24" height="24"/>
										</div>
										<div className={`${styles.storeBox_select} ${styles.storeBox_select02}`}>
											<img src="/images/icn_select02.svg" alt="" width="24" height="24"/>
										</div>
									</div>
								))}

								{/*
									<div className={styles.storeBox}>
										<div className={styles.storeBox_in}>
											<div className={styles.storeBox_img}>
												<img src="/images/logo_store_aeonstyle.png" alt="AEON STYLE" width="64" height="64"/>
											</div>
											<div className={styles.storeBox_info}>
												<p className={styles.storeBox_info_name}>イオンスタイル有明ガーデン</p>
												<p className={styles.storeBox_info_address}>東京都江東区有明2-1-8</p>
												<p className={styles.storeBox_info_dist}>34.5km</p>
											</div>
										</div>
										<div className={`${styles.storeBox_select} ${styles.storeBox_select01}`}>
											<img src="/images/icn_select01.svg" alt="" width="24" height="24"/>
										</div>
										<div className={`${styles.storeBox_select} ${styles.storeBox_select02}`}>
											<img src="/images/icn_select02.svg" alt="" width="24" height="24"/>
										</div>
									</div>
									<div className={styles.storeBox}>
										<div className={styles.storeBox_in}>
											<div className={styles.storeBox_img}>
												<img src="/images/logo_store_aeonstyle.png" alt="AEON STYLE" width="64" height="64"/>
											</div>
											<div className={styles.storeBox_info}>
												<p className={styles.storeBox_info_name}>イオンスタイル有明ガーデン</p>
												<p className={styles.storeBox_info_address}>東京都江東区有明2-1-8</p>
												<p className={styles.storeBox_info_dist}>34.5km</p>
											</div>
										</div>
										<div className={`${styles.storeBox_select} ${styles.storeBox_select01}`}>
											<img src="/images/icn_select01.svg" alt="" width="24" height="24"/>
										</div>
										<div className={`${styles.storeBox_select} ${styles.storeBox_select02}`}>
											<img src="/images/icn_select02.svg" alt="" width="24" height="24"/>
										</div>
									</div>
									<div className={styles.storeBox}>
										<div className={styles.storeBox_in}>
											<div className={styles.storeBox_img}>
												<img src="/images/logo_store_aeonstyle.png" alt="AEON STYLE" width="64" height="64"/>
											</div>
											<div className={styles.storeBox_info}>
												<p className={styles.storeBox_info_name}>イオンスタイル有明ガーデン</p>
												<p className={styles.storeBox_info_address}>東京都江東区有明2-1-8</p>
												<p className={styles.storeBox_info_dist}>34.5km</p>
											</div>
										</div>
										<div className={`${styles.storeBox_select} ${styles.storeBox_select01}`}>
											<img src="/images/icn_select01.svg" alt="" width="24" height="24"/>
										</div>
										<div className={`${styles.storeBox_select} ${styles.storeBox_select02}`}>
											<img src="/images/icn_select02.svg" alt="" width="24" height="24"/>
										</div>
									</div>
									<div className={styles.storeBox}>
										<div className={styles.storeBox_in}>
											<div className={styles.storeBox_img}>
												<img src="/images/logo_store_aeonstyle.png" alt="AEON STYLE" width="64" height="64"/>
											</div>
											<div className={styles.storeBox_info}>
												<p className={styles.storeBox_info_name}>イオンスタイル有明ガーデン</p>
												<p className={styles.storeBox_info_address}>東京都江東区有明2-1-8</p>
												<p className={styles.storeBox_info_dist}>34.5km</p>
											</div>
										</div>
										<div className={`${styles.storeBox_select} ${styles.storeBox_select01}`}>
											<img src="/images/icn_select01.svg" alt="" width="24" height="24"/>
										</div>
										<div className={`${styles.storeBox_select} ${styles.storeBox_select02}`}>
											<img src="/images/icn_select02.svg" alt="" width="24" height="24"/>
										</div>
									</div>
									*/}
							</>
						)
					}
				}
			})()
		}


		</div>
	</div>

	<div className={styles.startBox_btnBox}>
		<button className={`commonBtn commonBtn01 ${styles.startBox_commonBtn01} ${props.activeStore ? '' : 'is_disabled'}`} onClick={StartShopping}><span>お買い物をはじめる</span></button>
		<button className={`commonBtn commonBtn02 ${styles.startBox_commonBtn02}`} onClick={goIntro}><span>ご利用方法を見る</span></button>
		{/* <button className={`commonBtn commonBtn02 ${styles.startBox_commonBtn02} ${props.activeStore ? '' : 'is_disabled'}`} onClick={goIntro}><span>ご利用方法を見る</span></button> */}
	</div>
	</div>

</div>
</div>
</>
)

}
